<template>
  <svg
    width="62"
    height="42"
    viewBox="0 0 62 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="62"
      height="42"
      rx="8"
      fill="white"
    />
    <path
      opacity="0.7"
      d="M0.5 6C0.5 2.96243 2.96243 0.5 6 0.5H44.5H51H56C59.0376 0.5 61.5 2.96243 61.5 6V36C61.5 39.0376 59.0376 41.5 56 41.5H51H44.5H6C2.96244 41.5 0.5 39.0376 0.5 36V6Z"
      fill="white"
      stroke="#FF8A71"
    />
    <rect
      opacity="0.5"
      x="7"
      y="6"
      width="39"
      height="5"
      rx="2"
      fill="#6C6D84"
    />
    <rect
      opacity="0.3"
      x="7"
      y="15"
      width="14"
      height="5"
      rx="2"
      fill="#6C6D84"
    />
    <path
      d="M7.15 35L9.06 31.61L7.28 28.44H8.2L9.09 30.12C9.17667 30.2667 9.25667 30.4133 9.33 30.56C9.41 30.7067 9.5 30.8767 9.6 31.07H9.64C9.73333 30.8767 9.81333 30.7067 9.88 30.56C9.95333 30.4133 10.03 30.2667 10.11 30.12L10.98 28.44H11.86L10.07 31.65L11.98 35H11.06L10.1 33.23C10.0133 33.07 9.92333 32.9067 9.83 32.74C9.74333 32.5667 9.64667 32.38 9.54 32.18H9.5C9.40667 32.38 9.31667 32.5667 9.23 32.74C9.14333 32.9067 9.06 33.07 8.98 33.23L8.03 35H7.15ZM12.277 35L14.187 31.61L12.407 28.44H13.327L14.217 30.12C14.3036 30.2667 14.3836 30.4133 14.457 30.56C14.537 30.7067 14.627 30.8767 14.727 31.07H14.767C14.8603 30.8767 14.9403 30.7067 15.007 30.56C15.0803 30.4133 15.157 30.2667 15.237 30.12L16.107 28.44H16.987L15.197 31.65L17.107 35H16.187L15.227 33.23C15.1403 33.07 15.0503 32.9067 14.957 32.74C14.8703 32.5667 14.7736 32.38 14.667 32.18H14.627C14.5336 32.38 14.4436 32.5667 14.357 32.74C14.2703 32.9067 14.187 33.07 14.107 33.23L13.157 35H12.277ZM20.6359 30.8L20.2359 30.51L20.8059 29.57L19.8359 29.17L19.9859 28.71L21.0059 28.96L21.0959 27.88H21.5859L21.6759 28.95L22.7059 28.71L22.8559 29.17L21.8859 29.57L22.4459 30.51L22.0559 30.8L21.3459 29.94L20.6359 30.8ZM24.8155 30.8L24.4155 30.51L24.9855 29.57L24.0155 29.17L24.1655 28.71L25.1855 28.96L25.2755 27.88H25.7655L25.8555 28.95L26.8855 28.71L27.0355 29.17L26.0655 29.57L26.6255 30.51L26.2355 30.8L25.5255 29.94L24.8155 30.8ZM28.9952 30.8L28.5952 30.51L29.1652 29.57L28.1952 29.17L28.3452 28.71L29.3652 28.96L29.4552 27.88H29.9452L30.0352 28.95L31.0652 28.71L31.2152 29.17L30.2452 29.57L30.8052 30.51L30.4152 30.8L29.7052 29.94L28.9952 30.8Z"
      fill="#6C6D84"
    />
  </svg>
</template>
